import icon1 from "../images/impresion.png";
import icon2 from "../images/modelo.png";
import icon3 from "../images/3d-modeling.png";

const learnItems = [
    {
        id: 1,
        icon: icon1,
        title: "Aprende blender desde cero",
        information:
            "Conocerás la interfaz de BLENDER 3.0 y todo lo necesario para iniciar tu proyecto 3D",
    },
    {
        id: 2,
        icon: icon2,
        title: "Partiremos de un concepto",
        information:
            "Con base en el concepto presentado iniciaremos nuestro proyecto y usaremos las herramientas necesarias para la construccion de nuestro personaje.",
    },
    {
        id: 3,
        icon: icon3,
        title: "15 dias de entrenamiento ",
        information:
            "En Libel puedes aprender en corto tiempo, date la oportunidad y te esperamos en clase",
    },
];

export default learnItems;